import { BASE_URL_API } from 'constants/base-url-default'
import { getCookie } from 'utils/functions-cookie'

export const deleteEmployee = async (id: string) => {
  const authToken = getCookie('auth_token')

  const url = `${BASE_URL_API}/employees/${id}`

  const response = await fetch(url, {
    method: 'DELETE',
    headers: {
      Authorization: `Bearer ${authToken}`,
    },
  })

  if (!response.ok) {
    if (response.status === 403) {
      throw new Error('Sessão expirada')
    }
    throw new Error('Erro ao deletar funcionário')
  }
}
